import $ from 'jquery';
import LP from '../0-lp';

LP.dlgEditCodes = {
    prepare: function (selector) {
        $(selector).click(function () {
            var url = $(this).attr('url');
            var params = $(this).attr('url_params');
            var title = $(this).attr('title');
            LP.Dialog.open($.extend(params, {
                name: 'editCodes',
                ajax: url,
                request: params,
                title: title,
                width: 460,
                height: 400,
                onLoad: LP.dlgEditCodes.onLoad
            }));
            return false;
        });
    },
    onLoad: function () {
        $('#questionVarname').keyup(function () {
            $('td.varnameCol').html($('#questionVarname').attr('value'));
        });
    }
};